module.exports = __webpack_public_path__ + "static/the-selfish-gene-187830eb8defd9a3fc32b1eda49fb4d2.jpg";